import { render, staticRenderFns } from "./NumberOfIllnessPart.vue?vue&type=template&id=36483c6e&scoped=true&"
import script from "./NumberOfIllnessPart.vue?vue&type=script&lang=js&"
export * from "./NumberOfIllnessPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36483c6e",
  null
  
)

export default component.exports